import { jsx as _jsx } from "react/jsx-runtime";
import ProfileContainer from "@components/profile-container";
import React from "react";
var Products = function(param) {
    var guestData = param.guestData;
    return /*#__PURE__*/ _jsx(ProfileContainer, {
        guestData: guestData,
        type: "products"
    });
};
export var __N_SSG = true;
export default Products;
